import React from 'react'
import { useDispatch } from 'react-redux'
import { Container } from './styles'
import { useTranslation, } from 'react-i18next';
import { systemAddDialog } from '../../store/system/slice'
import VideoThumb from '../VideoThumb'
import { IVideos } from '../../store/videos/types';
import { roomVideoRemoveRequest, showVideoViewer } from '../../store/videos/slices';



interface Props {
    videos: IVideos[],
    parentId: string;
}
const VideoGallery: React.FC<Props> = ({ videos, parentId }) => {

    const { t } = useTranslation();

    const dispatch = useDispatch()

    return <Container >
        {videos.map((video, index) => <VideoThumb key={`video-${video.id}`} src={`${video.link}&width=120&height=120`}
            onDelete={() => {
                dispatch(systemAddDialog({
                    title: t("pages.videos.dialogs.remove_video"),
                    message: t("pages.videos.dialogs.remove_video_message"),
                    actions: [{
                        text: t("pages.videos.buttons.remove_video_confirm"),
                        action: () => {
                            dispatch(roomVideoRemoveRequest({
                                roomId: parentId,
                                videoId: video.id
                            }))
                        },
                        color: 'danger',
                        prependIcon: 'trash'
                    },
                    {
                        text: t("pages.videos.buttons.remove_video_cancel"),
                        action: () => { },
                        color: 'none'
                    }]
                }));
            }}
            onOpen={() => {
                dispatch(showVideoViewer({
                    arrayVideo: videos.map((video) => video.link),
                    positionVideo: index
                }))
            }}
        />)}
    </Container>
}

export default VideoGallery;